<app-record-modifications *ngIf="viewMode === 'RECORD_MODIFICATION'"></app-record-modifications>